// extracted by mini-css-extract-plugin
export default {"metric-threshold-filter":"metric-threshold-filter-6oGMl","metric-threshold-filter__label":"metric-threshold-filter__label-yYkIB"};